import React, { useState, useEffect } from "react";
import * as S from "./NovaCaixinhaStyle";
import {
  FaTimes,
  FaUser,
  FaFileContract,
  FaBoxOpen,
  FaCheck,
  FaArrowRight,
  FaArrowLeft,
  FaSearch,
  FaExclamationTriangle,
} from "react-icons/fa";
import { clientAdminService } from "../../../Services/clientAdminService";
import { contractAdminService } from "../../../Services/contractAdminService";
import { goldenBoxAdminService } from "../../../Services/goldenBoxAdminService";
import { formatCurrencyBRL } from "../../ASSETS/assets"; // Removido formatDate pois o DTO novo pode não ter data
import { useMessage } from "../../../Context/MessageContext";

export default function NovaCaixinha({ onClose, onUpdate }) {
  const { showMessage } = useMessage();
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState(1);

  // --- DADOS ---
  const [clientSearch, setClientSearch] = useState("");
  const [clientsList, setClientsList] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);

  // Lista de disponibilidade (ContractAviabilityForGoldenBox)
  const [availabilityList, setAvailabilityList] = useState([]);
  const [selectedAvailability, setSelectedAvailability] = useState(null);
  const [loadingContracts, setLoadingContracts] = useState(false);

  const [optionId, setOptionId] = useState("1"); // 1: Mensal, 2: Anual
  const [initialStatus, setInitialStatus] = useState("1"); // 1: Pendente

  // --- PASSO 1: BUSCA DE CLIENTES ---
  useEffect(() => {
    const timer = setTimeout(async () => {
      if (clientSearch.length > 2) {
        try {
          const response = await clientAdminService.searchClients(
            10,
            0,
            clientSearch
          );
          setClientsList(response.data || response || []);
        } catch (error) {
          console.error(error);
        }
      } else {
        setClientsList([]);
      }
    }, 500);
    return () => clearTimeout(timer);
  }, [clientSearch]);

  // --- SELEÇÃO DE CLIENTE E BUSCA DE DISPONIBILIDADE ---
  const handleSelectClient = async (client) => {
    setSelectedClient(client);
    setSelectedAvailability(null);
    setAvailabilityList([]);

    try {
      setLoadingContracts(true);

      const response = await contractAdminService.getAvailabilityAnalysis(client.id);
      const contracts = response.data || response; 
      setAvailabilityList(Array.isArray(contracts) ? contracts : []);

      setStep(2);
    } catch (error) {
      console.error(error);
      const msg =
        error.response?.data?.message ||
        "Erro ao buscar disponibilidade dos contratos.";
      showMessage(msg, "error");
    } finally {
      setLoadingContracts(false);
    }
  };

  // --- SELEÇÃO DE CONTRATO (DISPONIBILIDADE) ---
  const handleSelectAvailability = (item) => {
    // Bloqueia seleção se não houver disponibilidade em nenhuma modalidade?
    // Ou permite selecionar e avisa? Vamos permitir selecionar se pelo menos uma flag for true.
    if (
      !item.avaliableForAnualGoldenBoxType &&
      !item.avaliableForEndGoldenBoxType
    ) {
      showMessage(
        "Este contrato não é elegível para nenhuma modalidade.",
        "warning"
      );
      return;
    }

    setSelectedAvailability(item);

    // Auto-seleciona a opção viável se apenas uma estiver disponível
    if (
      item.avaliableForAnualGoldenBoxType &&
      !item.avaliableForEndGoldenBoxType
    ) {
      setOptionId("2"); // Anual
    } else if (
      !item.avaliableForAnualGoldenBoxType &&
      item.avaliableForEndGoldenBoxType
    ) {
      setOptionId("1"); // Mensal/Fim
    }
  };

  // --- NAVEGAÇÃO ---
  const nextStep = () => {
    if (step === 1 && !selectedClient)
      return showMessage("Selecione um cliente.", "info");
    if (step === 2 && !selectedAvailability)
      return showMessage("Selecione um contrato elegível.", "info");
    setStep((prev) => prev + 1);
  };

  const prevStep = () => {
    setStep((prev) => prev - 1);
  };

  // --- AÇÃO FINAL ---
  const handleCreate = async () => {
    if (!selectedClient || !selectedAvailability) return;

    // Validação final da modalidade escolhida vs disponibilidade
    if (
      optionId === "1" &&
      !selectedAvailability.avaliableForEndGoldenBoxType
    ) {
      return showMessage(
        "Este contrato não permite a modalidade Mensal/Fim.",
        "error"
      );
    }
    if (
      optionId === "2" &&
      !selectedAvailability.avaliableForAnualGoldenBoxType
    ) {
      return showMessage(
        "Este contrato não permite a modalidade Anual.",
        "error"
      );
    }

    try {
      setLoading(true);
      const payload = {
        clientId: selectedClient.id,
        contractId: selectedAvailability.contractId, // ID vem do DTO de disponibilidade
        goldenOptionId: parseInt(optionId),
        chosenStatus: parseInt(initialStatus),
      };

      await goldenBoxAdminService.createGoldenBox(payload);

      showMessage("Caixinha criada com sucesso!", "success");
      if (onUpdate) onUpdate();
      onClose();
    } catch (error) {
      console.error(error);
      const msg = error.response?.data?.message || "Erro ao criar caixinha.";
      showMessage(msg, "error");
    } finally {
      setLoading(false);
    }
  };

  // --- RENDER STEP 1 (Igual) ---
  const renderStep1 = () => (
    <S.StepContent>
      <S.Title>
        Quem é o <span>Cliente</span>?
      </S.Title>
      <div style={{ position: "relative" }}>
        <S.SearchInput
          placeholder="Digite Nome, CPF ou E-mail..."
          value={clientSearch}
          onChange={(e) => setClientSearch(e.target.value)}
          autoFocus
        />
        <FaSearch
          style={{ position: "absolute", right: 20, top: 20, color: "#666" }}
        />
      </div>

      <S.ListContainer>
        {clientsList.length === 0 && clientSearch.length > 2 && (
          <div style={{ textAlign: "center", color: "#555", marginTop: 20 }}>
            Nenhum cliente encontrado.
          </div>
        )}
        {clientsList.map((client) => (
          <S.CardItem
            key={client.id}
            selected={selectedClient?.id === client.id}
            onClick={() => handleSelectClient(client)}
          >
            <div>
              <strong>{client.name}</strong>
              <span>
                {client.cpfCnpj} • {client.email}
              </span>
            </div>
            {selectedClient?.id === client.id && <FaCheck color="#e6aa3a" />}
          </S.CardItem>
        ))}
      </S.ListContainer>
    </S.StepContent>
  );

  // --- RENDER STEP 2 (Com Analysis DTO) ---
  const renderStep2 = () => (
    <S.StepContent>
      <S.Title>
        Vincular a qual <span>Contrato</span>?
      </S.Title>

      <div
        style={{
          marginBottom: 20,
          padding: 15,
          borderLeft: "3px solid #e6aa3a",
          background: "#1a1a1a",
          color: "#eee",
          fontSize: 14,
          borderRadius: "0 4px 4px 0",
        }}
      >
        Cliente: <strong>{selectedClient?.name}</strong> <br />
        <span style={{ fontSize: 12, color: "#888" }}>
          CPF: {selectedClient?.cpfCnpj}
        </span>
      </div>

      {loadingContracts ? (
        <div style={{ textAlign: "center", padding: 40, color: "#e6aa3a" }}>
          Verificando disponibilidade...
        </div>
      ) : availabilityList.length === 0 ? (
        <div style={{ textAlign: "center", padding: 40, color: "#888" }}>
          Este cliente não possui contratos.
        </div>
      ) : (
        <S.ListContainer>
          {availabilityList.map((item) => {
            const isAvailable =
              item.avaliableForAnualGoldenBoxType ||
              item.avaliableForEndGoldenBoxType;

            return (
              <S.CardItem
                key={item.contractId}
                selected={selectedAvailability?.contractId === item.contractId}
                onClick={() => handleSelectAvailability(item)}
                style={{
                  opacity: isAvailable ? 1 : 0.5,
                  cursor: isAvailable ? "pointer" : "not-allowed",
                }}
              >
                <div>
                  <strong>Contrato #{item.contractId}</strong>

                  {/* Exibe flags de disponibilidade */}
                  <div style={{ display: "flex", gap: 10, marginTop: 4 }}>
                    {item.avaliableForEndGoldenBoxType && (
                      <span
                        style={{
                          fontSize: 10,
                          background: "#333",
                          padding: "2px 6px",
                          borderRadius: 4,
                          color: "#34d399",
                        }}
                      >
                        Mensal/Fim
                      </span>
                    )}
                    {item.avaliableForAnualGoldenBoxType && (
                      <span
                        style={{
                          fontSize: 10,
                          background: "#333",
                          padding: "2px 6px",
                          borderRadius: 4,
                          color: "#34d399",
                        }}
                      >
                        Anual
                      </span>
                    )}
                    {!isAvailable && (
                      <span
                        style={{
                          fontSize: 10,
                          color: "#ef4444",
                          display: "flex",
                          alignItems: "center",
                          gap: 4,
                        }}
                      >
                        <FaExclamationTriangle size={10} /> Indisponível
                      </span>
                    )}
                  </div>
                </div>

                <div style={{ alignItems: "flex-end" }}>
                  <span className="price">
                    {formatCurrencyBRL(item.contractTotalPrice)}
                  </span>
                  <span style={{ fontSize: 11 }}>
                    Faltam {item.monthsToEnd?.toFixed(1)} meses
                  </span>
                </div>
              </S.CardItem>
            );
          })}
        </S.ListContainer>
      )}
    </S.StepContent>
  );

  // --- RENDER STEP 3 (Configuração) ---
  const renderStep3 = () => (
    <S.StepContent>
      <S.Title>
        Configurar <span>Caixinha</span>
      </S.Title>

      <label
        style={{
          color: "#888",
          fontSize: 12,
          display: "block",
          marginBottom: 8,
        }}
      >
        MODALIDADE DE RENDIMENTO
      </label>
      <S.OptionGrid>
        {/* Opção 1: Mensal (1.3%) */}
        <S.OptionCard
          selected={optionId === "1"}
          onClick={() => {
            if (selectedAvailability?.avaliableForEndGoldenBoxType)
              setOptionId("1");
            else showMessage("Indisponível para este contrato.", "warning");
          }}
          style={{
            opacity: selectedAvailability?.avaliableForEndGoldenBoxType
              ? 1
              : 0.4,
          }}
        >
          <h4>SAQUE TOTAL NO FIM</h4>
          <p>Rendimento de 1.3% a.m.</p>
          {!selectedAvailability?.avaliableForEndGoldenBoxType && (
            <small style={{ color: "#ef4444" }}>Indisponível</small>
          )}
        </S.OptionCard>

        {/* Opção 2: Anual (1.0%) */}
        <S.OptionCard
          selected={optionId === "2"}
          onClick={() => {
            if (selectedAvailability?.avaliableForAnualGoldenBoxType)
              setOptionId("2");
            else showMessage("Indisponível para este contrato.", "warning");
          }}
          style={{
            opacity: selectedAvailability?.avaliableForAnualGoldenBoxType
              ? 1
              : 0.4,
          }}
        >
          <h4>SAQUE ANUAL - 1 ANO</h4>
          <p>Rendimento de 1.0% a.m.</p>
          {!selectedAvailability?.avaliableForAnualGoldenBoxType && (
            <small style={{ color: "#ef4444" }}>Indisponível</small>
          )}
        </S.OptionCard>
      </S.OptionGrid>

      <label
        style={{
          color: "#888",
          fontSize: 12,
          display: "block",
          marginBottom: 8,
        }}
      >
        STATUS INICIAL
      </label>
      <S.OptionGrid>
        <S.OptionCard
          selected={initialStatus === "1"}
          onClick={() => setInitialStatus("1")}
        >
          <h4>Pendente</h4>
          <p>Aguardar aprovação</p>
        </S.OptionCard>
        <S.OptionCard
          selected={initialStatus === "2"}
          onClick={() => setInitialStatus("2")}
        >
          <h4>Ativo</h4>
          <p>Aprovar Imediatamente</p>
        </S.OptionCard>
      </S.OptionGrid>

      <S.Title style={{ fontSize: 16, marginTop: 10, marginBottom: 10 }}>
        Resumo
      </S.Title>
      <S.SummaryBox>
        <div className="row">
          <span>Cliente</span>
          <span>{selectedClient?.name}</span>
        </div>
        <div className="row">
          <span>Contrato</span>
          <span>
            #{selectedAvailability?.contractId} -{" "}
            {formatCurrencyBRL(selectedAvailability?.contractTotalPrice || 0)}
          </span>
        </div>
        <div className="row">
          <span>Modalidade</span>
          <span>
            {optionId === "1" ? "Saque Mensal (1.3%)" : "Saque Anual (1.0%)"}
          </span>
        </div>
        <div className="row">
          <span>Status</span>
          <span
            style={{ color: initialStatus === "1" ? "#fbbf24" : "#34d399" }}
          >
            {initialStatus === "1" ? "Pendente" : "Ativo"}
          </span>
        </div>
      </S.SummaryBox>
    </S.StepContent>
  );

  return (
    <S.Overlay onClick={onClose}>
      <S.ModalContainer onClick={(e) => e.stopPropagation()}>
        <S.ModalHeader>
          <h2>
            <FaBoxOpen /> Nova Caixinha
          </h2>
          <button onClick={onClose}>
            <FaTimes />
          </button>
        </S.ModalHeader>

        <S.StepperContainer>
          <S.StepItem active={step === 1} completed={step > 1}>
            <div className="circle">
              {step > 1 ? <FaCheck size={12} /> : "1"}
            </div>
            <span>Cliente</span>
          </S.StepItem>
          <S.StepItem active={step === 2} completed={step > 2}>
            <div className="circle">
              {step > 2 ? <FaCheck size={12} /> : "2"}
            </div>
            <span>Contrato</span>
          </S.StepItem>
          <S.StepItem active={step === 3}>
            <div className="circle">3</div>
            <span>Confirmar</span>
          </S.StepItem>
        </S.StepperContainer>

        <S.ModalBody>
          {step === 1 && renderStep1()}
          {step === 2 && renderStep2()}
          {step === 3 && renderStep3()}
        </S.ModalBody>

        <S.ModalFooter>
          {step > 1 ? (
            <S.Button secondary onClick={prevStep}>
              <FaArrowLeft /> Voltar
            </S.Button>
          ) : (
            <div />
          )}

          {step < 3 ? (
            <S.Button
              primary
              onClick={nextStep}
              disabled={step === 1 ? !selectedClient : !selectedAvailability}
            >
              Próximo <FaArrowRight />
            </S.Button>
          ) : (
            <S.Button primary onClick={handleCreate} disabled={loading}>
              {loading ? "Criando..." : "Finalizar e Criar"} <FaCheck />
            </S.Button>
          )}
        </S.ModalFooter>
      </S.ModalContainer>
    </S.Overlay>
  );
}
